'use client';

import { forwardRef } from 'react';
import type { SkeletonProps as MantineSkeletonProps } from '@mantine/core';
import { Skeleton as MantineSkeleton } from '@mantine/core';

import type { LockedProps } from '../types';

export type SkeletonProps = Omit<MantineSkeletonProps, LockedProps>;

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>((props, ref) => {
  return <MantineSkeleton ref={ref} {...props} />;
});

Skeleton.displayName = 'Skeleton';
